import BaseItem from './BaseItem';
import { initNewModules } from 'lib/util/helpers';

export default class ContactResult extends BaseItem {
	constructor($ctx : JQuery) {
		super($ctx);
	}

	public updateState(current : boolean | null, active : boolean | null) {
		super.updateState(current, active);
		if (active) {
			initNewModules(this.$ctx);
		}
	}
}



// WEBPACK FOOTER //
// typescript://../clientlibs/js/lib/contact/ContactResult.ts